<template>
  <div class="padding-sm">
    <div class="bg-white">
      <div class="text-center">
        <template v-if="talentVideoUrl">
          <video :src="talentVideoUrl" controls="true" style="width: 80%;height: 200px"></video>
          <div class="btn-rerecording" @click="talentVideoUrl=null;video=[]">
            <van-icon name="replay" size="14" />重新上传
          </div>
        </template>
        <van-uploader
          v-show="!talentVideoUrl"
          v-model="video"
          accept="video/*"
          :max-count="1"
          ref="upload"
          :max-size="30 * 1024 * 1024"
          @oversize="onOversize"
          :after-read="videoRead"
        >
          <van-button class="uploadButton">上传视频</van-button>
        </van-uploader>
      </div>
    </div>
    <div class="text-center margin-tb">
      <van-button type="primary" size="large" @click="submit">保存</van-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Button,
  Toast,
  Dialog,
  Field,
  Icon,
  Uploader,
  Tab,
  Tabs,
  CellGroup,
  Cell
} from "vant";
import { saveTalentVideo } from "@/api/clerk/clerk";
import { uploadFile } from "@/api/cos";

Vue.use(Button)
  .use(Toast)
  .use(Dialog)
  .use(Field)
  .use(Icon)
  .use(Uploader)
  .use(Tab)
  .use(Tabs)
  .use(CellGroup)
  .use(Cell);

export default {
  name: "talentVideo",
  data() {
    return {
      autoHeight: { minHeight: 100 },
      talentVideoUrl: null,
      video: []
    };
  },
  methods: {
    videoRead(file) {
      Toast.loading("加载中");
      uploadFile(this.$store.state.shop.id, "clerk/soundCard", file.file)
        .then(url => {
          Toast.clear();
          this.talentVideoUrl = url;
        })
        .catch(err => {
          Dialog.alert({
            title: "上传失败",
            message: err
          });
          this.talentVideoUrl = null;
          this.video = [];
        })
        .finally(() => {
          Toast.clear();
        });
    },
    onOversize() {
      Toast("文件大小不能超过30M");
    },

    submit() {
      Toast.loading({
        mask: true,
        message: "请稍候..."
      });
      saveTalentVideo(this.talentVideoUrl).then(res => {
        Toast.clear();
        const data = res.data;
        if (data.code == 0) {
          this.video = [];
          Dialog.alert({
            title: "保存成功"
          });
          this.$router.back();
        } else {
          Dialog.alert({
            title: "保存失败",
            message: data.msg
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.returnClose {
  font-size: 16px;
  color: darkgrey;
}

.addButton {
  //width: 100%;
  //height: 35px;
  //border-radius: 30px;
  background: #04ade0;
  font-size: 15px;
  color: white;
  border: none;
}

.contentField {
  font-size: 16px;
  border: 1px solid #efefef;
}

.uploadButton {
  display: inline-block;
  line-height: 44px;
  min-width: 92px;
  margin: 30px;
  height: 44px;
  font-size: 15px;
  background: #04ade0;
  color: white;
  white-space: nowrap;
}

.record-status {
  text-align: center;
  position: relative;
  left: 50%;
  transform: translateX(-50%);

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 92px;
    height: 100%;
    overflow: hidden;
    cursor: pointer;
    opacity: 0;
    z-index: 3;
  }

  .btn-rerecording {
    display: inline-flex;
    color: #333;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    align-items: center;

    .van-icon {
      margin-right: 3px;
    }
  }
}

/deep/ .van-cell:after {
  border: none;
}
</style>
